import PropTypes from 'prop-types'
import { MarkerItem } from '@calendly/booking-kit'
import { TitleText } from '@calendly/ui/components/typography'


const Marker = ({ text }) => (
  <MarkerItem>
    <TitleText level={2} size="large">{text}</TitleText>
  </MarkerItem>
)

Marker.propTypes = {
  text: PropTypes.string.isRequired
}

export default Marker
